import { DateField, DateInput, Filter, FunctionField, SelectInput, TextField, TextInput } from 'react-admin'
import { usePageTitle } from 'shared/components/PageTitle/PageTitle'

import { CTDatagrid } from 'components/CTDatagrid'
import { CarrierMCChoices, IssueStatusChoices, IssueTypeChoices } from '../../helpers/constants'
import { CustomReferenceField } from '../Common/CustomReferenceFields'
import { EmailField, FullNameField } from '../Fields'
import CTList from '../List'

const IssueFilter = (props: any) => (
  <Filter {...props}>
    <TextInput label="Search" source="search" alwaysOn />
    <SelectInput label="Status" source="status" choices={IssueStatusChoices} />
    <SelectInput label="Type" source="type" choices={IssueTypeChoices} />
    <DateInput label="Date created" source="date_created" />
    <SelectInput
      label="Carrier"
      source="job__product_subscription__carrier__mc_number"
      choices={CarrierMCChoices}
    />
  </Filter>
)

const JobIssueList = (props: any) => {
  usePageTitle('Job isssues')

  return (
    <CTList bulkActionButtons={false} filters={<IssueFilter />} {...props}>
      <CTDatagrid optimized>
        <DateField
          label="Date created"
          source="date_created"
          options={{ timeZoneName: 'short' }}
          showTime={true}
        />
        <CustomReferenceField
          source="job"
          label="Job"
          sortable={false}
          baseUrl="/jobs"
          representationFunction={(job: any) => job.human_id}
        />
        <TextField sortable={false} label="Status" source="status" />
        <TextField sortable={false} label="Type" source="type" />
        <FunctionField
          label="Reported for"
          render={(record: any) => {
            return <FullNameField record={record.reported_for} />
          }}
        />
        <FunctionField
          label="Reported by"
          render={(record: any) => {
            return <EmailField record={record.reported_by} />
          }}
        />
      </CTDatagrid>
    </CTList>
  )
}

export default JobIssueList
